export default __webpack_public_path__ + "static/media/Scales.0c30bdc0.svg";